import React, { useCallback, useState } from "react"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import Page from "../../components/Page"
import EventDateSection from "./EventDateSection"
import ModalQrCode from "../../components/Modal/ModalQrCode"
import { QrCodeEntityType, QrCodeResult } from "../../globalStates/ExhibitorDataTypes"
import { loadQrCodeInfo } from "../../globalStates/ConfigDataState"

const EventDatesPage: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const eventDatesStates = useExhibitorDataState().getEventDates()

    const [qrCodeModalVisible, setQrCodeModalVisible] = useState<boolean>(false)
    const [qrCodeUrl, setQrCodeUrl] = useState<string | undefined>()
    const [qrCodeName, setQrCodeName] = useState<string | undefined>()

    const onClickQrCode = useCallback((eventDateId: string) => {
        loadQrCodeInfo(QrCodeEntityType.EVENTDATE, eventDateId)
            .then((response: QrCodeResult) => {
                setQrCodeName(response.entityName)
                setQrCodeUrl(response.url)
                setQrCodeModalVisible(true)
            })
            .catch((error: any) => {
                setQrCodeName(undefined)
                setQrCodeUrl(undefined)
                setQrCodeModalVisible(true)
            })
    }, [])

    return (
        <Page description={branding.configuration.eventDatesPage.pageDescription}>
            {eventDatesStates?.map((eventDateState, index) => (
                <EventDateSection
                    key={eventDateState.id.get()}
                    eventDateState={eventDateState}
                    index={index}
                    onClickQrCode={onClickQrCode}
                />
            ))}

            {qrCodeModalVisible && (
                <ModalQrCode
                    entityType={QrCodeEntityType.EVENTDATE}
                    name={qrCodeName}
                    url={qrCodeUrl}
                    visible={qrCodeModalVisible}
                    onClose={() => {
                        setQrCodeModalVisible(false)
                    }}
                />
            )}
        </Page>
    )
}

export default EventDatesPage
